import { backendServices } from './backend.service';

export const services = { ...backendServices };
